export default {"src":"/_next/static/media/whatsapp.a343923c.svg","height":200,"width":200};